import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import WeeklyReport from './WeeklyReport';
import React, { useEffect, useState, useContext } from "react";
import { QtdContext } from "../../../context/qtdContext";
import Loading from 'react-fullscreen-loading';

const MONTH_NAMES = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

function formatDate(date) {
    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

// function getWeeksInMonth(year, month) {
//     const weeks = [];
//     let date = new Date(year, month, 1);
//     const lastDay = new Date(year, month + 1, 0);

//     let start = new Date(year, month, 1);

//     if (start.getDay() !== 1) {
//         const firstWeekEnd = new Date(start);
//         firstWeekEnd.setDate(start.getDate() + (7 - (start.getDay() || 7)));
//         weeks.push({ start: new Date(start), end: firstWeekEnd });
//         start = new Date(firstWeekEnd);
//         start.setDate(start.getDate() + 1);
//     }

//     while (start <= lastDay) {
//         const end = new Date(start);
//         end.setDate(start.getDate() + 6);
//         if (end > lastDay) end.setDate(lastDay.getDate());
//         weeks.push({ start: new Date(start), end: new Date(end) });
//         start = new Date(end);
//         start.setDate(start.getDate() + 1);
//     }

//     return weeks;
// }
function getWeeksInMonth(year, month) {
    const weeks = [];
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let current = new Date(firstDayOfMonth);

    // Переместим текущую дату на ближайший понедельник назад (или оставим, если это ПН)
    const dayOfWeek = current.getDay() === 0 ? 7 : current.getDay(); // воскресенье = 7
    current.setDate(current.getDate() - (dayOfWeek - 1));

    while (current <= lastDayOfMonth) {
        const weekStart = new Date(current);
        const weekEnd = new Date(current);
        weekEnd.setDate(weekEnd.getDate() + 6);

        // Ограничим границы текущего месяца
        const boundedStart = weekStart < firstDayOfMonth ? firstDayOfMonth : weekStart;
        const boundedEnd = weekEnd > lastDayOfMonth ? lastDayOfMonth : weekEnd;

        weeks.push({
            start: new Date(boundedStart),
            end: new Date(boundedEnd),
        });

        current.setDate(current.getDate() + 7); // переход на следующую неделю
    }

    return weeks;
}


function findCurrentWeekIndex(year, month, weeks) {
    const today = new Date();
    if (today.getFullYear() !== year || today.getMonth() !== month) return 0;
    return weeks.findIndex(week => today >= week.start && today <= week.end);
}

const WeekReports = () => {
    const years = [2025, 2026];
    const today = new Date();
    const { shops } = useContext(QtdContext);
    const [loading, seloading] = useState(false);

    const [selectedYearIndex, setSelectedYearIndex] = useState(
        years.indexOf(today.getFullYear()) >= 0 ? years.indexOf(today.getFullYear()) : 0
    );
    const [selectedMonthIndex, setSelectedMonthIndex] = useState(today.getMonth());
    const [selectedWeekIndex, setSelectedWeekIndex] = useState(0);
    const [selectedShopIndex, setSelectedShopIndex] = useState(0);

    useEffect(() => {
        const currentYear = years[selectedYearIndex];
        const currentMonth = selectedMonthIndex;
        const weeks = getWeeksInMonth(currentYear, currentMonth);
        const currentWeek = findCurrentWeekIndex(currentYear, currentMonth, weeks);
        setSelectedWeekIndex(currentWeek >= 0 ? currentWeek : 0);
    }, [selectedYearIndex, selectedMonthIndex]);

    const currentYear = years[selectedYearIndex];
    const currentMonth = selectedMonthIndex;
    const currentWeeks = getWeeksInMonth(currentYear, currentMonth);
    const currentWeek = currentWeeks[selectedWeekIndex];
    const currentShop = shops[selectedShopIndex];

    return (
        <>
            <Tabs selectedIndex={selectedYearIndex} onSelect={setSelectedYearIndex}>
                <TabList style={{
                    border: '2px solid white',
                    margin: '5px',
                    padding: '5px',
                    borderRadius: '15px'
                }} className="custom-tablist">
                    {years.map((year) => (
                        <Tab key={year}>{year}</Tab>
                    ))}
                </TabList>

                {years.map((year, yearIdx) => (
                    <TabPanel key={year}>
                        <Tabs
                            selectedIndex={yearIdx === selectedYearIndex ? selectedMonthIndex : 0}
                            onSelect={(index) => {
                                if (yearIdx === selectedYearIndex) {
                                    setSelectedMonthIndex(index);
                                }
                            }}
                        >
                            <TabList style={{
                                border: '2px solid white',
                                margin: '5px',
                                padding: '5px',
                                borderRadius: '15px'
                            }} className="custom-tablist">
                                {MONTH_NAMES.map((month, idx) => (
                                    <Tab key={idx}>{month}</Tab>
                                ))}
                            </TabList>

                            {MONTH_NAMES.map((_, monthIndex) => {
                                const weeks = getWeeksInMonth(year, monthIndex);
                                const isCurrentMonth = yearIdx === selectedYearIndex && monthIndex === selectedMonthIndex;
                                return (
                                    <TabPanel key={monthIndex}>
                                        <Tabs
                                            selectedIndex={isCurrentMonth ? selectedWeekIndex : 0}
                                            onSelect={(index) => {
                                                if (isCurrentMonth) {
                                                    setSelectedWeekIndex(index);
                                                }
                                            }}
                                        >
                                            <TabList style={{
                                                border: '2px solid white',
                                                margin: '5px',
                                                padding: '5px',
                                                borderRadius: '15px'
                                            }} className="custom-tablist scrollable-tablist">
                                                {weeks.map((week, index) => (
                                                    <Tab key={index}>
                                                        {`${formatDate(week.start)} - ${formatDate(week.end)}`}
                                                    </Tab>
                                                ))}
                                            </TabList>

                                            {weeks.map((week, index) => (
                                                <TabPanel key={index}>
                                                    <Tabs
                                                        selectedIndex={selectedShopIndex}
                                                        onSelect={(i) => setSelectedShopIndex(i)}
                                                    >
                                                        <TabList style={{
                                                            border: '2px solid white',
                                                            margin: '5px',
                                                            padding: '5px',
                                                            borderRadius: '15px'
                                                        }} className="custom-tablist scrollable-tablist">
                                                            {shops.map((shop, index2) => (
                                                                <Tab key={`${shop.id}_${index2}`}>
                                                                    {shop.name}
                                                                </Tab>
                                                            ))}
                                                        </TabList>

                                                        {shops.map((shop, index2) => (
                                                            <TabPanel key={`${shop.id}_${index2}`}>
                                                                <WeeklyReport
                                                                    shop={shop}
                                                                    startDate={week.start}
                                                                    endDate={week.end}


                                                                />
                                                            </TabPanel>
                                                        ))}
                                                    </Tabs>
                                                </TabPanel>
                                            ))}
                                        </Tabs>
                                    </TabPanel>
                                );
                            })}
                        </Tabs>
                    </TabPanel>
                ))}
            </Tabs>

            {/* Стили только для этого компонента */}
            <style>{`
    .custom-tablist {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        margin-bottom: 8px;
        overflow-x: auto;
    }

    .react-tabs__tab {
        color: white;
        background: transparent;
        border: none;
        padding: 8px 16px;
        border-radius: 6px 6px 0 0;
        white-space: nowrap;
        font-weight: 500;
        cursor: pointer;
    }

    .react-tabs__tab--selected {
        color: black !important;
        background: white;
        border: 1px solid #ccc;
        border-bottom: none;
        z-index: 1;
    }

    .react-tabs__tab:hover {
        opacity: 0.8;
    }

    .scrollable-tablist {
        overflow-x: auto;
        scrollbar-width: thin;
    }

    .scrollable-tablist::-webkit-scrollbar {
        height: 4px;
    }

    .scrollable-tablist::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 2px;
    }
`}</style>

        </>
    );
};

export default WeekReports;
